export const DEFAULT_ROUTE = '/request';

export const routes = [DEFAULT_ROUTE];
